import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["color", "disabled", "active", "invert", "focus", "tagName", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// состояния в массиве выставляются следующим образом default, active, disabled

var colorsMap = {
  light: {
    closeIcon: ['tertiary', 'secondary-invert', 'disabled'],
    title: ['primary', 'primary-invert', 'disabled'],
    icon: ['primary', 'primary-invert', 'disabled']
  },
  'light-invert': {
    closeIcon: ['tertiary', 'secondary-invert', 'disabled'],
    title: ['primary', 'primary-invert', 'disabled'],
    icon: ['primary', 'primary-invert', 'disabled']
  },
  dark: {
    closeIcon: ['tertiary-fake-invert', 'tertiary', 'disabled-fake-invert'],
    title: ['primary-fake-invert', 'black', 'disabled-fake-invert'],
    icon: ['primary-fake-invert', 'black', 'disabled-fake-invert']
  },
  'dark-invert': {
    closeIcon: ['tertiary-fake-invert', 'tertiary', 'disabled-fake-invert'],
    title: ['primary-fake-invert', 'black', 'disabled-fake-invert'],
    icon: ['primary-fake-invert', 'black', 'disabled-fake-invert']
  }
};
export var getColors = function getColors(_ref) {
  var color = _ref.color,
    active = _ref.active,
    disabled = _ref.disabled,
    invert = _ref.invert;
  var scope = "".concat(color).concat(invert ? '-invert' : '');
  var scopedMap = colorsMap[scope];
  var index = active ? 1 : 0;
  if (disabled) {
    index = 2;
  }
  return {
    icon: scopedMap.icon[index],
    title: scopedMap.title[index],
    closeIcon: scopedMap.closeIcon[index]
  };
};
var getStyleVariables = function getStyleVariables(_ref2) {
  var _objectSpread2;
  var invert = _ref2.invert,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style,
    disabled = _ref2.disabled,
    active = _ref2.active,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'light' : _ref2$color;
  var suffix = "".concat(color).concat(invert ? '-invert' : '');
  var stateSuffix = active ? '-active' : '';
  if (disabled) {
    stateSuffix = '-disabled';
  }
  return _objectSpread(_objectSpread({}, style), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, '--chips-bg', "var(--chips-bg-".concat(suffix).concat(stateSuffix, ")")), _defineProperty(_objectSpread2, '--chips-subtitle-color', "var(--chips-subtitle-color-".concat(suffix).concat(stateSuffix, ")")), _objectSpread2));
};
export var dataConverter = function dataConverter(_ref3) {
  var _ref3$color = _ref3.color,
    color = _ref3$color === void 0 ? 'light' : _ref3$color,
    disabled = _ref3.disabled,
    activeProp = _ref3.active,
    invert = _ref3.invert,
    focus = _ref3.focus,
    _ref3$tagName = _ref3.tagName,
    tagName = _ref3$tagName === void 0 ? 'button' : _ref3$tagName,
    style = _ref3.style,
    otherProps = _objectWithoutProperties(_ref3, _excluded);
  var active = Boolean(activeProp || focus);
  var colors = getColors({
    color: color,
    active: active,
    disabled: disabled,
    invert: invert
  });
  return _objectSpread(_objectSpread({
    active: active,
    disabled: disabled,
    colors: colors,
    tagName: tagName,
    style: getStyleVariables({
      style: style,
      color: color,
      invert: invert,
      active: active,
      disabled: disabled
    })
  }, tagName === 'button' ? {
    type: 'button',
    disabled: disabled
  } : {}), otherProps);
};